import { ChangeDetectorRef, Component, EventEmitter, forwardRef, inject, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';

// Segmented Yes/No control for reactive forms. Defaults to the same 'Yes'/'No' values as
// BooleanSelectComponent so forms can switch over without logic changes; pass
// [yesValue]="true" [noValue]="false" for real booleans. A null (or unknown) value shows no selection.
@Component({
    selector: 'app-yes-no-toggle',
    imports: [MatButtonToggleModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YesNoToggleComponent),
            multi: true
        }
    ],
    templateUrl: './yes-no-toggle.component.html',
    styleUrl: './yes-no-toggle.component.scss'
})
export class YesNoToggleComponent implements ControlValueAccessor {
  @Input() yesValue: any = 'Yes';
  @Input() noValue: any = 'No';
  @Input() yesLabel = 'Yes';
  @Input() noLabel = 'No';
  @Input() ariaLabelledby: string | null = null;

  @Output() valueChanged = new EventEmitter<any>();

  value: any = null;
  disabled = false;
  private cdr = inject(ChangeDetectorRef);

  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  onToggleChange(event: MatButtonToggleChange) {
    this.value = event.value;
    this.onChange(event.value);
    this.onTouched();
    this.valueChanged.emit(event.value);
  }
}
